import type { FaireProductEntity } from "../../entity_types/product";

export const p_wydz8gtxew: FaireProductEntity = {
  token: "p_wydz8gtxew",
  type: "product",
  name: "Large Capacity Striped Tote Bag Casual Versatile Canvas Shopping Bag",
  brandToken: "b_999ccmmbkw",
  brandName: "Halcyon Outfitters®",
  imageUrl:
    "https://cdn.faire.com/fastly/b5e05603dc8230b47abb63ad26a2100956b062138de92ff5eb774094a0ed7474.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dc88d1c99c854ef4929199069e72c20abf86861172e4d048e0dbde428472678c.jpeg",
    "https://cdn.faire.com/fastly/7e5dc729438adcd62cc8807d4fa28ee08da414e12062ae677a2abee8193644c7.jpeg",
    "https://cdn.faire.com/fastly/a24422e0af74b8f9ecf2faa83b567917606721818464b76ddd0a4cae8b5e024c.jpeg",
    "https://cdn.faire.com/fastly/f12bb207e005a2e379a0189f50fee5d40c675996a9433538874d6abfdd0184c6.jpeg",
    "https://cdn.faire.com/fastly/98546fb6ffb6f1bfe380e413a5d1fb56f4b760c62d5665a41669f06a7f77f13c.jpeg",
    "https://cdn.faire.com/fastly/64df4e9206343c76d146a75ac85ec774774a56f6d8dc60a24dc3fa80031d3cf4.jpeg",
    "https://cdn.faire.com/fastly/b07f9a354d1edc751083c5ba21c15fced77e3739ff3af421508fc5c92dd0746d.jpeg",
    "https://cdn.faire.com/fastly/da72d02fab771017076b8bcbd8649ea05b59039646f961db5cf3789691068088.jpeg",
    "https://cdn.faire.com/fastly/f6ba3387a4ff4924fbd9d791c78b537a1ab35e15b79d53560b7db783858608ad.jpeg",
    "https://cdn.faire.com/fastly/65e4dd4abf1c70ca2f2251675e11430b39bb50083f5aca7206028632fb354a99.jpeg",
    "https://cdn.faire.com/fastly/25917c1d2cde842da73c5720de4d86d6f48a771e121183fd539b651dfdf36fbd.jpeg",
  ],
  priceDollars: 7.9,
  description:
    "This large capacity tote bag is designed for everyday use with a chic urban minimalist style. Made from durable canvas, it features a variety of trendy patterns and vibrant colors that are perfect for any occasion.\nFeatures: \n * Material: Durable canvas \n * Size: Large \n * Interior Structure: Phone pocket \n * Style: Urban minimalist \n * Closure Type: Open top \n * Thickness: Medium \n * Double shoulder straps for comfort \nWith multiple design options, including floral, plaid, and striped patterns, this tote is not only functional but also a fashionable accessory for your daily outfits. It's perfect for shopping, commuting, and any day out. \n",
  tags: [],
  msrpDollars: 15.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:06.433Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
